const PATH = 'fe.components.learning_resources.header';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Learning Resources'
  },
  myEducators: {
    key: `${PATH}.my_educators`,
    defaultValue: 'My Educators'
  },
  allResources: {
    key: `${PATH}.all_resources`,
    defaultValue: 'All Resources'
  },
  recommend: {
    key: `${PATH}.recommend`,
    defaultValue: 'Recommend'
  },
  resources: {
    key: `${PATH}.resources`,
    defaultValue: 'Resources'
  },
  educator: {
    key: `${PATH}.educator`,
    defaultValue: 'Login as Educator'
  }
};

export default messages;
